import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { config } from '../helpers/config';

const CalendarDialog = ({ open, onClose }) => {
    const embedUrl = config.calendarEmbedUrl;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: { xs: 0, sm: 3.5 },
                    bgcolor: 'background.paper',
                    maxHeight: '90vh',
                    border: '1px solid rgba(16,42,58,0.1)',
                    boxShadow: '0 32px 90px rgba(4,31,48,0.22)',
                    overflow: 'hidden',
                }
            }}
        >
            <DialogTitle sx={{
                px: { xs: 2.5, sm: 4 },
                py: { xs: 2.2, sm: 2.8 },
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                bgcolor: '#082F49',
                color: 'white'
            }}>
                <Box>
                    <Typography variant="overline" sx={{ color: '#84E4E1', fontWeight: 800, letterSpacing: 1.3 }}>Choose a time</Typography>
                    <Typography component="div" sx={{ mt: 0.2, fontSize: { xs: '1.35rem', sm: '1.65rem' }, fontWeight: 800, letterSpacing: '-0.03em' }}>Book a discovery call</Typography>
                </Box>
                <IconButton
                    aria-label="close calendar"
                    onClick={onClose}
                    sx={{
                        color: 'white',
                        bgcolor: 'rgba(255,255,255,0.08)',
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.14)',
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0, overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                <Box
                    component="iframe"
                    src={embedUrl}
                    sx={{
                        width: '100%',
                        height: { xs: '70vh', sm: '620px' },
                        border: 'none',
                        display: 'block',
                    }}
                    title="Book Appointment"
                    frameBorder="0"
                />
            </DialogContent>
            <DialogActions sx={{
                px: { xs: 2.5, sm: 4 },
                py: 1.8,
                borderTop: '1px solid rgba(16,42,58,0.08)',
                bgcolor: '#F7FBFC'
            }}>
                <Button
                    onClick={onClose}
                    variant="text"
                    color="primary"
                    sx={{
                        px: 2
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CalendarDialog;
